import { SORT_OPTIONS } from "@/utils/applicationConstants";
import { sharedService } from "@/modules/shared/store/services/shared-service";
import { RECEIVE_GET_PROPERTY_USES } from "@/redux/constants/property_uses";

const DEFAULT_FILTERS = { page: 1, size: 30, sortBy: SORT_OPTIONS[0].id, searchTerm: "" };

const getPropertyUses = sharedService.injectEndpoints({
  endpoints: builder => ({
    getPropertyUses: builder.query({
      query: () => {
        const params = new URLSearchParams();
        Object.entries(DEFAULT_FILTERS).forEach(([k, v]) => { if (v) params.set(k, v); });
        return `parameters/property-uses?${params}`;
      },
      transformResponse: response => response.items,
      providesTags: ["PropertyUses"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch({ type: RECEIVE_GET_PROPERTY_USES, propertyUses: data });
        } catch { /* handled by RTK Query error state */ }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetPropertyUsesQuery } = getPropertyUses;

